<template>
  <v-app>
    <v-toolbar
      app
      fixed
      clipped-left
    >
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat icon :href="linkPageUrl" color="grey" target="_blank">
        <v-icon>info</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container>
        <v-layout xs12 sm10 md8 column justify-center>
          <v-card class="ma-2 grey lighten-5">
            <v-card-text class="pa-3">
              <v-layout column>
                <v-flex>
                  <v-layout row>
                    <v-flex xs6>
                      <v-card>
                        <v-card-text class="pa-2">
                          <v-select
                            v-model="conditions.numberOfSyllables"
                            :items="numberOfSyllablesList"
                            label="音節数"
                            hide-details
                          ></v-select>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs6 class="ml-2">
                      <v-card>
                        <v-card-text class="pa-2">
                          <v-text-field
                            v-model="conditions.headword"
                            label="見出し語"
                            hide-details
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex v-if="conditions.numberOfSyllables !== -1" class="mt-1">
                  <v-card>
                    <v-card-title class="pt-2 pr-2 pb-0 pl-2">
                      第1音節
                    </v-card-title>
                    <v-card-text class="pa-2">
                      <v-layout row wrap>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.consonants1" label="声母" :items="consonantList" :syllableIndex="1" :valueNodeLevel="2"/>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.vowels1" label="韻母" :items="vowelList" :syllableIndex="1" :valueNodeLevel="2"/>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.tones1" label="声調" :items="toneList" :syllableIndex="1" :valueNodeLevel="1"/>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex v-if="!conditions.numberOfSyllables || conditions.numberOfSyllables > 1" class="mt-1">
                  <v-card>
                    <v-card-title class="pt-2 pr-2 pb-0 pl-2">
                      第2音節
                    </v-card-title>
                    <v-card-text class="pa-2">
                      <v-layout row wrap>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.consonants2" label="声母" :items="consonantList" :syllableIndex="2" :valueNodeLevel="2"/>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.vowels2" label="韻母" :items="vowelList" :syllableIndex="2" :valueNodeLevel="2"/>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <SyllablePartsComboBox v-model="conditions.tones2" label="声調" :items="toneList" :syllableIndex="2" :valueNodeLevel="1"/>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex class="mt-1">
                  <v-layout row>
                    <v-flex xs10>
                      <v-btn block color="primary" @click.native="searchButtonClicked">
                        <span class="subheading">検索</span>
                        <v-icon right dark>search</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs-2 class="ml-2">
                      <v-btn block @click.native="clearSearch">
                        <span class="subheading">クリア</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <Paginator v-model="page" :pagination="pagination" />
          <v-layout column class="pa-2">
            <v-card v-if="searchResult && searchResult.length === 0">
              <v-card-text>検索結果はありません。</v-card-text>
            </v-card>
            <v-card v-for="word in searchResult" :key="word.wordId" class="mb-2"
              :class="{ 'light-green lighten-3': word.language === 'ja' }">
              <v-card-title primary-title class="pt-3 pr-3 pl-3" :class="{ 'pb-0': word.meaning, 'pb-3': !word.meaning }">
                <span class="headline">{{ word.headword }}</span>
                <span v-if="word.pronunciation" class="ml-2">[ {{ word.pronunciation }} ]</span>
                <v-chip v-if="word.yomi" color="green" text-color="white" small disabled>
                  <v-avatar class="green darken-4" title="読み">よ</v-avatar>
                  {{ word.yomi }}
                </v-chip>
                <v-tooltip top>
                  <v-chip v-if="word.kantai" color="orange" slot="activator" text-color="white" small disabled>
                    <v-avatar class="orange darken-4" title="簡体字">簡</v-avatar>
                    {{ word.kantai }}
                  </v-chip>
                  <span class="display-2">{{ word.kantai }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-chip v-if="word.hantai" color="deep-orange lighten-2" slot="activator" text-color="white" small disabled>
                    <v-avatar class="deep-orange darken-2" title="繁体字">繁</v-avatar>
                    {{ word.hantai }}
                  </v-chip>
                  <span class="display-2">{{ word.hantai }}</span>
                </v-tooltip>
                <SoundPlayButton v-if="word.media && word.media.length > 0" :file="mediaFilePath + word.media[0].path"/>
                <v-spacer></v-spacer>
                <v-btn :to="{ name: 'admin_word_edit', params: { wordId: word.wordId } }"
                       v-if="isEditable"
                       title="この単語を編集..."
                       icon small class="grey--text">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="word.meaning" class="pa-3">
                <ol class="word-meanings">
                  <li>{{ word.meaning }}</li>
                </ol>
              </v-card-text>
            </v-card>
          </v-layout>
          <Paginator v-if="searchResult && searchResult.length > 5" v-model="page" :pagination="pagination" />
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style lang="scss" scoped>
ol.word-meanings > li:only-child {
  list-style: none;
}
</style>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import SyllablePartsComboBox from '@/components/SyllablePartsComboBox.vue'
import SoundPlayButton from '@/components/SoundPlayButton.vue'
import Paginator from '@/components/Paginator.vue'

export default {
  name: 'Search',
  components: {
    SyllablePartsComboBox,
    SoundPlayButton,
    Paginator,
  },
  data () {
    return {
      title: '中国語音韻検索',
      mediaFilePath: 'media/',
      page: 1,
      conditions: {
        headword: '',
        numberOfSyllables: 1,
        consonants1: [],
        vowels1: [],
        tones1: [],
        consonants2: [],
        vowels2: [],
        tones2: [],
      },
    };
  },
  computed: {
    ...mapState([
      'consonantList',
      'vowelList',
      'toneList',
      'numberOfSyllablesList',
      'searchResult',
      'pagination',
      'isEditable',
      'linkPageUrl',
    ]),
    ...mapGetters([
    ]),
  },
  watch: {
    page() {
      // ページネーターによるページ遷移
      this.search();
    },
  },
  async mounted() {
  },
  methods: {
    ...mapMutations([
      'setLoading',
      'clearSearchResult',
    ]),
    ...mapActions([
      'searchWords',
    ]),
    async searchButtonClicked() {
      this.page = 1; // 必ず 1 ページ目に戻す
      await this.search();
    },
    async search() {
      this.setLoading(true);
      try {
        const params = {};
        params['page'] = this.page;
        if (this.conditions.headword) params['headword'] = this.conditions.headword;
        if (this.conditions.numberOfSyllables !== -1) {
          params['numberOfSyllables'] = this.conditions.numberOfSyllables || 'null'; // null のときは文字列で null を送信
          if (this.conditions.consonants1 && this.conditions.consonants1.length > 0) params['consonants1'] = this.conditions.consonants1.join(',');
          if (this.conditions.vowels1 && this.conditions.vowels1.length > 0) params['vowels1'] = this.conditions.vowels1.join(',');
          if (this.conditions.tones1 && this.conditions.tones1.length > 0) params['tones1'] = this.conditions.tones1.join(',');
          if (this.conditions.numberOfSyllables > 1 || !this.conditions.numberOfSyllables) { // 2 以上か null (4 音節以上)
            if (this.conditions.consonants2 && this.conditions.consonants2.length > 0) params['consonants2'] = this.conditions.consonants2.join(',');
            if (this.conditions.vowels2 && this.conditions.vowels2.length > 0) params['vowels2'] = this.conditions.vowels2.join(',');
            if (this.conditions.tones2 && this.conditions.tones2.length > 0) params['tones2'] = this.conditions.tones2.join(',');
          }
        }
        await this.searchWords(params);
      } catch (e) {
        console.log(e);
        alert('検索に失敗しました。\n' + e.message);
      } finally {
        this.setLoading(false);
      }
    },
    clearSearch() {
      this.setConditions(null);
      this.clearSearchResult();
    },
    setConditions(conditions) {
      conditions = conditions || {
        headword: '',
        numberOfSyllables: 1,
        consonants1: [],
        vowels1: [],
        tones1: [],
        consonants2: [],
        vowels2: [],
        tones2: [],
      };
      this.conditions = conditions;
    },
  },
}
</script>

